import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function JoinOurEvents() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="6674" id="kirim-berita-cta" className="w-full py-24 md:py-32 lg:py-40 bg-background flex flex-col items-center justify-center border-y border-border shadow-sm">
      <div className="container mx-auto px-6 md:px-8 lg:px-12 max-w-7xl flex flex-col items-center text-center">
        <h2 className="font-sans text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 max-w-4xl leading-tight tracking-tight">
          Punya Informasi Penting?
        </h2>
        
        <p className="font-sans text-base md:text-lg lg:text-xl text-secondary max-w-2xl mb-12 leading-relaxed md:leading-loose">
          Jadilah bagian dari jurnalisme warga ABADI.NEWS
        </p>

        <div ref={ref} className={`transform transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[20px]"}`}>
          <Button asChild variant="outline" className="bg-primary border-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground hover:border-primary hover:-translate-y-1 rounded-md px-8 py-4 md:px-10 md:py-6 text-base md:text-lg lg:text-xl font-bold h-auto transition-all duration-300 shadow-md">
            <Link to="#">
              Kirim Berita Sekarang
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}